angular.module('controllers').controller('statisticController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window',
            function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval, $window) {

        $rootScope.path = '/statistic';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'statistic';
		$scope.pathTemplate = 'statistics';
		$scope.title = 'Statistici';
        $rootScope.typeId = 'id';
        $scope.defaultItem = 10;

		angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.additionals['publicPath'] = '/images/app';
        $scope.additionals['jsonPath'] = '/json';

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0, 0, 0, 0);
        $scope.search.dateTo = current_init_date;

        $scope.printReport = $window;
        $scope.isLoadingPrinter = false;
        $scope.printPreview = function (ev, path, availableColumns, columns) {
            $scope.isLoadingPrinter = true;
            var popup = $scope.printReport.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
            popup.document.open();

            Crud.search($scope.search, path, 1, 'p')
                .success(function (data) {
                    $scope.isLoadingPagination = false;
                    $scope.isLoadingPrinter = false;

                    $scope.additionals['buttonDisabledPagination'] = false;
                    var printColumns = {};
                    if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
                        angular.forEach(columns, function (item, index) {
                            if (availableColumns.indexOf(index) >= 0) {
                                printColumns[index] = item;
                            }
                        });
                    } else {
                        printColumns = columns;
                    }
                    var title = 'Raport ';
                    if($scope.search['reportType'] == 'reportDetail') {
                        title = title + 'detaliat';
                    }
                    if($scope.search['reportType'] == 'reportDaily') {
                        title = title + 'zilnic';
                    }
                    if($scope.search['reportType'] == 'reportMonthly') {
                        title = title + 'lunar';
                    }
                    if($scope.search['reportType'] == 'reportDailySource') {
                        title = title + 'zilnic pe surse de provenienta';
                    }
                    if($scope.search['reportType'] == 'reportSource') {
                        title = title + 'pe surse de provenienta';
                    }
                    if($scope.search['reportType'] == 'reportShipping') {
                        title = title + 'privind taxa de transport';
                    }
                    if($scope.search['reportType'] == 'reportDiscount') {
                        title = title + 'privind situatia reducerilor';
                    }
                    title = title + '  ';
                    if ($scope.search['dateFrom']) {
                        title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeFrom']) {
                        title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
                    }
                    if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
                        title = title + '   ';
                    }
                    if ($scope.search['dateTo']) {
                        title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
                    }
                    if ($scope.search['timeTo']) {
                        title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
                    }

                    var html = '<div class="report-print">';
                    var orders = data.data;
                    if (orders.length > 0) {
                        html = html + '<table><tr>';
                        html = html + '<th>Nr.</th>';
                        angular.forEach(printColumns, function (itemColumn, keyColumn) {
                            if(!itemColumn['nonDisplay']) {
                                html = html + '<th>' + itemColumn['label'] + '</th>';
                            }
                        });
                        html = html + '</tr>';

                        var nos_orders = 0;
                        var nos_slots = 0;
                        var values_orders = 0;
                        var shipping_values_orders = 0;
                        var discount_values_orders = 0;

                        angular.forEach(orders, function (item, key) {
                            html = html + '<tr>';
                            var keys = key + 1;
                            html = html + '<td>' + keys + '</td>';
                            angular.forEach(printColumns, function (itemColumn, keyColumn) {
                                if(!itemColumn['nonDisplay']) {
                                    if (itemColumn['filterType'] == 'select') {
                                        if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                            html = html + '<td>' + $scope.additionals['associativeColumn'](printColumns[keyColumn], item[keyColumn]) + '</td>';
                                        } else {
                                            html = html + '<td></td>';
                                        }
                                    } else {
                                        if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                            html = html + '<td>' + item[keyColumn] + '</td>';
                                        } else {
                                            html = html + '<td></td>';
                                        }
                                    }
                                }
                            });
                            html = html + '</tr>';

                            nos_orders = nos_orders + parseInt(item['nos_orders']);
                            nos_slots = nos_slots + parseInt(item['nos_slots']);
                            values_orders = values_orders + parseFloat(item['values_orders']);
                            shipping_values_orders = shipping_values_orders + parseFloat(item['shipping_values_orders']);
                            discount_values_orders = discount_values_orders + parseFloat(item['discount_values_orders']);

                        });

                        html = html + '<tr>';
                        html = html + '<td>Total</td>';
                        angular.forEach(printColumns, function (itemColumn, keyColumn) {
                            if(!itemColumn['nonDisplay']) {
                                if (keyColumn == 'order_numbers') {
                                    html = html + '<td class="align-right total">' + order_numbers + '</td>';
                                } else if (keyColumn == 'nos_orders') {
                                    html = html + '<td class="align-right total">' + nos_orders + '</td>';
                                } else if (keyColumn == 'nos_slots') {
                                    html = html + '<td class="align-right total">' + nos_slots + '</td>';
                                } else if (keyColumn == 'values_orders') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](values_orders) + '</td>';
                                } else if (keyColumn == 'shipping_values_orders') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](shipping_values_orders) + '</td>';
                                } else if (keyColumn == 'discount_values_orders') {
                                    html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](discount_values_orders) + '</td>';


                                } else {
                                    html = html + '<td></td>';
                                }
                            }

                        });
                        html = html + '</tr>';

                        html = html + '</table>';
                    }

                    popup.document.write('<!DOCTYPE html><html><head><title>'+ title +'</title>'
                        + '<link rel="stylesheet" type="text/css" href="/css/print-preview.css" />'
                        + '</head><body onload="window.print(); window.close();">'
                        + html
                        + '</body></html>');
                    //popup.document.close();

                }).error(function (data) {
                $scope.isLoadingPagination = false;
                $scope.errors = data.errors;
            });

        }

        $scope.cancelSearchReport = function (ev, path, reportType) {
            $scope.search.dateFrom = '';
            $scope.search.dateTo = '';

            if($scope.searchControl == true) {
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
            }
            angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200',function() {
                angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
            });
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            form.reset();

            $timeout($scope.removeDate, 500);

        }

        if($location.path() == $scope.path+'/statisticTotalOrder') {
            $scope.search.period = 'daily';
            $scope.columns = {
                'date':{'label':'Data', 'filter':1, 'filterType':'input'},
                'nos_orders':{'label':'Nr. comenzi', 'filter':1, 'filterType':'input'},
                'nos_slots':{'label':'Nr. sloturi', 'filter':1, 'filterType':'input'},
                'shipping_values_orders':{'label':'Total valoare livrare ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'discount_values_orders':{'label':'Total valoare discounturi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'values_orders':{'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };
            $scope.search['reportType'] = 'statisticTotalOrder';
            $scope.additionals['reportType'] = 'statisticTotalOrder';
            $scope.title = 'Comenzi / Statistici zilnice/lunare';
            $scope.classAction = 'td-small';
        }

        if($location.path() == $scope.path+'/statisticShippingOrder') {
            $scope.search.period = 'daily';
            $scope.columns = {
                'date':{'label':'Data/Luna', 'filter':1, 'filterType':'input'},
                'shipping_no_orders_1':{'label':'Nr. comenzi cu livrare la domiciliu', 'filter':1, 'filterType':'input'},
                'shipping_no_orders_2':{'label':'Nr. comenzi cu livrare cu ridicare', 'filter':1, 'filterType':'input'},
                'shipping_value_orders_1':{'label':'Valoare comenzi cu livrare la domiciliu('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'shipping_value_orders_2':{'label':'Valoare comenzi cu livrare cu ridicare ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                'values_orders':{'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };
            $scope.search['reportType'] = 'statisticShippingOrder';
            $scope.additionals['reportType'] = 'statisticShippingOrder';
            $scope.title = 'Comenzi / Statistici zilnice/lunare';
            $scope.classAction = 'td-small';

        }

        if($location.path() == $scope.path+'/statisticSourceOrder') {
            $scope.order_source = {};
            $scope.order_source.options = [
                {'id': '', 'value' : ''},
                {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
                {'id': 1, 'value': 'Telefon', 'icon' : $scope.additionals['publicAppPath']+'/phone.png'},
                {'id': 2, 'value':  $rootScope.nameProject, 'icon' : $scope.additionals['publicAppPath']+'/logo_ssmall.png'},
                {'id': 4, 'value': 'FoodPanda', 'icon' : $scope.additionals['publicAppPath']+'/foodpanda.png'},
                {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
                {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
                {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
            ];
            $scope.search.period = 'daily';
            $scope.columns = {};
            $scope.columns['date'] = {'label':'Data/Luna', 'filter':1, 'filterType':'input'};
            angular.forEach($scope.order_source.options, function (item, index) {
                if(index != '' && item['id'] != 3){
                     $scope.columns['source_no_orders_'+item['id']] = {'label':'Nr. comenzi '+ item['value'], 'filter':1, 'filterType':'input'};
                     $scope.columns['source_value_orders_'+item['id']] = {'label':'Valoare comenzi '+ item['value'], 'filter':1, 'filterType':'input'};
                }
            });
            $scope.columns['values_orders'] = {'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'};

            $scope.search['reportType'] = 'statisticSourceOrder';
            $scope.additionals['reportType'] = 'statisticSourceOrder';
            $scope.title = 'Comenzi / Statistici zilnice/lunare';
            $scope.classAction = 'td-small';
        }

        if($location.path() == $scope.path+'/statisticDiscountOrder') {
            //discount_id - 0 for discount products, 1 for client discount, 2 loyalty point discount, 3 order discount;
            $scope.discounts = [
                {'id' : 0, 'value' : 'Reducere produs'},
                {'id' : 1, 'value' : 'Reducere client'},
               /* {'id' : 2, 'value' : 'Reducere pct. fidelizare'},*/
                {'id' : 3, 'value' : 'Reducere comanda'}
            ];
            $scope.search.period = 'daily';
            $scope.columns = {};
            $scope.columns['date'] = {'label':'Data/Luna', 'filter':1, 'filterType':'input'};
            angular.forEach($scope.discounts, function (item, index) {
                $scope.columns['discount_no_orders_'+item['id']] = {'label':'Nr. comenzi '+ item['value'], 'filter':1, 'filterType':'input'};
                $scope.columns['discount_value_orders_'+item['id']] = {'label':'Valoare comenzi '+ item['value'], 'filter':1, 'filterType':'input'};

            });
            $scope.columns['values_orders'] = {'label':'Total valoare comenzi ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'};

            $scope.search['reportType'] = 'statisticDiscountOrder';
            $scope.additionals['reportType'] = 'statisticDiscountOrder';
            $scope.title = 'Comenzi / Statistici zilnice/lunare';
            $scope.classAction = 'td-small';
        }

        if($location.path() == $scope.path+'/statisticDeliveryTimeDriver') {
            $scope.search.period = 'daily';
            $scope.columns = {
                'date':{'label':'Data/Luna', 'filter':1, 'filterType':'input'},
                'drivers':{'label':'Soferi/Timp mediu de livrare per sofer', 'filter':1, 'filterType':'input'},
                'value_delivery_time_grouped':{'label':'Timp mediu de livrare per zi/luna', 'filter':1, 'filterType':'input'}
            };
            $scope.search['reportType'] = 'statisticDeliveryTimeDriver';
            $scope.additionals['reportType'] = 'statisticDeliveryTimeDriver';
            $scope.title = 'Comenzi / Statistici zilnice/lunare';
            $scope.classAction = 'td-small';

            /* get drivers */
            $scope.additionals['searchTermDriverSingle'];
            $scope.additionals['clearSearchTermDriverSingle'] = function() {
                $scope.additionals['searchTermDriverSingle'] = '';
            };
            $scope.additionals['onSearchChangeDriverSingle'] = function(ev) {
                ev.stopPropagation();
            };
            $scope.getDrivers = function () {
                Crud.get($scope.path + '/getDrivers')
                    .success(function (data) {
                        if (angular.isUndefined($scope.additionals['drivers'])) {
                            $scope.additionals['drivers'] = [];
                        }
                        $scope.additionals['driversAll'] = data.drivers;

                    });
            }
            $scope.getDrivers();
        }


	}]
)
